import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { VendorService } from 'src/app/services/core/services/vendors/vendor.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-add-vendor',
  templateUrl: './add-vendor.component.html',
  styleUrls: ['./add-vendor.component.css']
})
export class AddVendorComponent implements OnInit {
  vendorForm!: FormGroup
  submitted = false;
  vendorId: any;
  companies: any;
  selectedCompany: any = '';
  syncToken: any;
  quickBookId: any;

  constructor(
    private companyService: CompanyService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private vendorService: VendorService,
    private fb: FormBuilder) { }

  ngOnInit(): void {
    this.getCompanies()
    this.buildForm();

    this.activatedRoute.params
      .pipe(untilDestroyed(this)).subscribe((params) => {
        this.vendorId = params["id"];
        if (this.vendorId) {
          this.getVendorById();
        }
      }
      );
  }

  buildForm() {
    this.vendorForm = this.fb.group({
      FullyQualifiedName: ['', Validators.required],
      PrimaryEmailAddr: this.fb.group({
        Address: ['', Validators.required],
      }),
      DisplayName: ['', Validators.required],
      Notes: [''],
      PrimaryPhone: this.fb.group({
        FreeFormNumber: ['', [Validators.required, Validators.pattern(/^\+?[0-9]{10}$/)]],

      }),
      BillAddr: this.fb.group({
        Line1: ['', Validators.required],
        CountrySubDivisionCode: ['', Validators.required],
        City: ['', Validators.required],
        PostalCode: ['', Validators.required],
        Country: ['', Validators.required],
      }),
      reference: this.fb.group({
        name: [''],
        id: [''],
      })
    });
  }


  getVendorById() {
    this.vendorService.getVendorById(this.vendorId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.vendorForm.patchValue(data)
        this.selectedCompany = data.company?.id || data.company;
        this.syncToken = data.SyncToken;
        this.quickBookId = data.Id;
      }
    })
  }

  get form() {
    return this.vendorForm.controls;
  }

  get primaryEmailAddr() {
    return this.vendorForm.get('PrimaryEmailAddr') as FormGroup;
  }

  get primaryPhone() {
    return this.vendorForm.get('PrimaryPhone') as FormGroup;
  }

  get billAddr() {
    return this.vendorForm.get('BillAddr') as FormGroup;
  }

  get reference() {
    return this.vendorForm.get('reference') as FormGroup;
  }

  onSave() {
    this.submitted = true;
    if (this.vendorForm.invalid || !this.selectedCompany) {
      return;
    }
    const payload = {
      ...this.vendorForm.value,
      FullyQualifiedName: this.vendorForm.value.FullyQualifiedName || this.vendorForm.value.DisplayName,
      company: this.selectedCompany?.id || this.selectedCompany
    }

    if (this.vendorId) {
      payload.SyncToken = this.syncToken,
      payload.Id = this.quickBookId
    }

    this.vendorService.saveVendor(this.vendorId, payload).pipe(untilDestroyed(this)).subscribe({
      next: (data: any) => {
        if (data) {
          this.router.navigateByUrl('/vendors')
        }
      },
      error: (err) => {
        sweetAlert("Error", err, "error", "Ok");
      }
    })
  }

  getCompanies() {
    this.companyService.getCompanies({ status: 'created' }).subscribe((data: any) => {
      if (data) {
        this.companies = data.results
      }
    })
  }

  onSelectAddress(place: any): void {

    const selectedAddress = place.address_components;
    // city
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';

    // state
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.short_name : '';

    // Postal Code
    const postalCode = selectedAddress.find((data: any) =>
      data.types.includes('postal_code')
    );
    const postalCodeValue = postalCode ? postalCode.long_name : '';

    // Country
    const country = selectedAddress.find((data: any) =>
      data.types.includes('country')
    );
    const countryName = country ? country.long_name : '';

    this.vendorForm.patchValue({
      BillAddr: {
        Line1: place.formatted_address,
        CountrySubDivisionCode: stateName,
        City: cityName,
        PostalCode: postalCodeValue,
        Country: countryName
      }
    });


  }
}
